(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invitation', {
                parent: 'admin',
                url: '/invitation',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle: 'jotApp.invitation.detail.title'
                },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/invitation/invite-user.html',
                    controller: 'InviteUserController',
                    controllerAs: 'vm'
                }
            },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invitationList', {
                parent: 'admin',
                url: '/invitation-list',
                data: {
                    authorities: ['ROLE_DOMAIN_ADMIN'],
                    pageTitle:'jotApp.invitation.detail.titleList'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/admin/invitation/invitation-list.html',
                        controller: 'InvitationListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invitation');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
